module.exports = __webpack_public_path__ + "img/07.4c1e2e12.png";